var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../store';
const roomScreenShareAudioVolumeSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings.roomScreenShareAudioVolume, (roomScreenShareAudioVolume) => roomScreenShareAudioVolume);
$RefreshReg$(_react_refresh_temp_1, "roomScreenShareAudioVolumeSelector$createSelector");
const AudioElm = ({ track }) => {
    _react_refresh_temp_3();
    const roomScreenShareAudioVolume = useAppSelector(roomScreenShareAudioVolumeSelector);
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        const el = ref.current;
        if (el) {
            (_a = track.audioTrack) === null || _a === void 0 ? void 0 : _a.attach(el);
            el.volume = roomScreenShareAudioVolume;
        }
        return () => {
            var _a;
            if (el) {
                (_a = track.audioTrack) === null || _a === void 0 ? void 0 : _a.detach(el);
            }
        };
    }, [track]);
    useEffect(() => {
        const el = ref.current;
        if (el) {
            el.volume = roomScreenShareAudioVolume;
        }
    }, [roomScreenShareAudioVolume]);
    return (_jsx("div", { style: { display: 'none' }, children: _jsx("audio", { autoPlay: true, ref: ref }) }));
};
_react_refresh_temp_2 = AudioElm;
$RefreshReg$(_react_refresh_temp_2, "AudioElm");
_react_refresh_temp_3(AudioElm, "28Mr6CuOVpud1rQET4Jmf+ipFPw=", false, () => [useAppSelector]);
export default AudioElm;
